
import React from 'react';
import GenericTableEditor from '../../components/admin/GenericTableEditor';

const CorporateLiabilitiesEditor = () => {
  const columns = [
    { key: 'liability-en', label: 'Liability (EN)', type: 'text' },
    { key: 'liability-ms', label: 'Liability (MS)', type: 'text' },
    { key: 'description-en', label: 'Description (EN)', type: 'textarea' },
    { key: 'description-ms', label: 'Description (MS)', type: 'textarea' },
    { key: 'url', label: 'URL', type: 'text' },
  ];

  return <GenericTableEditor tableName="corporate_liabilities" columns={columns} title="Corporate Liabilities Manager" />;
};

export default CorporateLiabilitiesEditor;
